import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#DB2F91" }}>Problem</span>
            </h2>
            <p>
              The challenge was to come up with a review algorithm that allows
              for nuanced ratings, as opposed to a general game rating. This was
              needed to ensure that gamers could get a nuanced understanding of
              the quality of a game depending on their personal quality markers.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/button-smasher/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1257}
              height={1270}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
